export default "__VITE_ASSET__bfc68623__"